import React from 'react';
import { useFormContext } from 'react-hook-form';
import styles from '@components/join/join.module.scss';
import classnames from 'classnames/bind';
const cx = classnames.bind(styles);

interface IAgreeListItem {
  name: string;
  title: string;
  isRequired: boolean;
  detailLink?: string;
  onChangeChecked?: React.ChangeEventHandler;
}

const AgreeListItem = (props: IAgreeListItem) => {
  const { register } = useFormContext();

  return (
    <li className={cx('listItem')}>
      <div className={cx('labelWrap')}>
        <label className={cx('label')}>
          <input
            {...register(props.name, { required: props.isRequired })}
            type="checkbox"
            className={cx('input', 'hidden')}
            onChange={props.onChangeChecked}
          />
          <span className={cx('checkbox')} />
          {props.title}
        </label>
        <a href={props.detailLink} className={cx('link')} target="_blank" rel="noreferrer">
          자세히
        </a>
      </div>
    </li>
  );
};

export default AgreeListItem;
